const ITEMS = [
  "Assurance Auto",
  "Habitation",
  "Mutuelle & Prévoyance",
  "Assurance Vie",
  "Professionnels",
  "Devis sous 24h",
  "Conseiller dédié",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative border-y hairline bg-slate2/60 py-6 overflow-hidden"
      aria-hidden="true"
    >
      <div className="marquee-track">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0 items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-serif text-2xl sm:text-3xl italic text-ivory/50 whitespace-nowrap px-8">
                  {item}
                </span>
                <span className="text-amber text-lg">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
